interface IAppConfig {
    apiUrl: string
}

const config: IAppConfig = {
    apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:7071/api/'
};

export default config;